<template>
  <div class="document-page">
    <splitpanes
      class="default-theme"
      @resized="handlePaneResized"
      @resize="resizingPane"
    >
      <pane :size="leftPaneSize" min-size="25" class="pane-scroll">
        <DocumentList
          :key="documentListKey"
          :searchType="searchType"
          :searchPattern="searchPattern"
        />
      </pane>
      <pane :size="100 - leftPaneSize" min-size="25" class="pane-scroll" style="overflow-y: auto;">
        <DocumentViewer :saveDocumentChanges="true" :isResizing="isResizing" />
      </pane>
    </splitpanes>
  </div>
</template>

<script>
import DocumentList from '@/components/search/results/list/DocumentList';
import DocumentViewer from '@/components/search/results/DocumentViewer';
import { Splitpanes, Pane } from 'splitpanes';
import 'splitpanes/dist/splitpanes.css';

export default {
    components: {
        DocumentList,
        DocumentViewer,
        Splitpanes,
        Pane
    },
    data() {
        return {
            documentListKey: 0,
            searchType: '',
            searchPattern: '',
            leftPaneSize: localStorage.documentSearchPaneSize || 50,
            isResizing: false
        };
    },
    methods: {
        resizingPane() {
            if (this.isResizing) return;
            this.isResizing = true;
        },
        handlePaneResized($event) {
            const leftPaneSize = $event[0].size;
            localStorage.documentSearchPaneSize = leftPaneSize;
            this.isResizing = false;
        }
    },
    created() {
        this.searchType = this.$route.params.search_type;
        this.searchPattern = this.$route.params.search_pattern;
    },
    beforeRouteUpdate(to, from, next) {
        this.searchType = to.params.search_type;
        this.searchPattern = to.params.search_pattern;
        this.documentListKey += 1;
        next();
    }
};
</script>
<style scoped>
.document-page {
  height: 90vh;
  display: flex;
  flex-direction: column;
}

.splitpanes.default-theme {
  flex: 1;
  height: 100%;
}

.pane-scroll {
  height: 100%;
}
</style>
